// initial state
const state = {
  tradeStatus: {
    'WAIT_BUYER_PAY': '等待付款', // 交易创建，等待买家付款。
    'TRADE_CLOSED': '已关闭', // 在指定时间段内未支付时关闭的交易；在交易完成全额退款成功时关闭的交易。
    'TRADE_SUCCESS': '充值成功', // 交易成功，且可对该交易做操作，如：多级分润、退款等。
    'TRADE_PENDING': '等待收款', // 等待卖家收款（买家付款后，如果卖家账号被冻结）。
    'TRADE_FINISHED': '交易成功', // 交易成功且结束，即不可再做任何操作。
    'TRADE_ABNORMAL': '交易异常', // 交易异常,支付宝反馈数据与服务器数据不一致。
  }
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const clbAlipayFlow = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/clb-alipay-flow/clb-alipay-flow.store.js